import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { ChatListPage } from "@/features/chat/components/chat-list-page";
import { useI18n } from "@/providers/i18n-provider";

function ChatRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Tus mensajes`)}
      description={t(msg`Inicia sesión para chatear con otros coleccionistas.`)}
    >
      <ChatListPage />
    </AuthPlaceholder>
  );
}

export const chatRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/chat",
  component: ChatRoutePage,
});
